import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import NewColumnNameChooser from './new-column-name-chooser'

/**
 * Execute this on a file upload error to check for and handle missing column
 * exceptions. If the proper data is available, then this will move on to the
 * column mapper. Else false is returned
 *
 * @param xhr the response from the file upload
 * @param {Wizard} [options.wizard] the wizard to progress forward, if needed
 * @param {boolean} advance if true, automatically move to the next step
 * @returns {boolean} true if the wizard was setup and pushed forward; false if
 * 					  the error is not a missing columns exception
 */
function handleMissingColumnsException(xhr, options, advance = true) {
	if (_.isNil(xhr)) return false

	const data = xhr.responseJSON
	const isMissingColumnsEx = isMissingColumnsException(xhr)
	if (isMissingColumnsEx && options.wizard) {
		options.mappingData = data
		if (data.revisionId) {
			options.params.revisionId = data.revisionId
		}
		if (data.fileId) {
			options.fileId = data.fileId
		}
		if (!_.isNil(options.replaceAllRecords)) {
			if (!options.params) {
				options.params = {}
			}
			options.params.replaceAllRecords = options.replaceAllRecords
			delete options.replaceAllRecords
		}
		// #58698 only want to add the remap columns step to the wizard if there are columns
		// to actually map
		if (advance) {
			_.invoke(options.wizard, 'showNextStep', true)
			options.wizard.next(options)
		}
	}
	return isMissingColumnsEx
}

function isMissingColumnsException(xhr) {
	const data = xhr?.responseJSON
	return !_.isNil(data) && !_.isNil(data?.available)
}

function hasColumnsToRemapTo(xhr) {
	const data = xhr?.responseJSON
	return !_.isEmpty(data?.available)
}

/**
 * Displays a view that could cause a Dataset's column names to change. If this
 * occurs, the view will be converted to a wizard that allows the user to map
 * the new column names to the old ones so everything works correctly
 */
const NewColumnNameChooserWizard = Wizard.extend({

	showMappings: false,

	/**
	 * @param {Object} view the main view to display
	 * @param {String} [options.url] the endpoint to talk to when the user
	 * 		re-submits the form
     * @param {Function} [options.paramProvider] provides the parameters needed
	 * 		when re-submitting the form
	 */
	initialize(view, options = {}) {
		this.view = view
		var views = this.getViews()
		var opts = _.extend({ views }, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	showNextStep(show) {
		if (this.showMappings != show) {
			this.showMappings = show
			this.setViews(this.getViews())
			this.render()
		}
	},

	next: function() {
		this.setViews(this.getViews())
		Wizard.prototype.next.apply(this, arguments)
	},

	getViews: function() {
		let views = [ this.view ]
		if (this.showMappings) {
			views.push(NewColumnNameChooser)
		}
		return views
	},

	/**
	 * @param submitHandler performs the submit action on the 'new-column-name-chooser'
	 * screen instead of the default action
	 */
	setSubmitHandler(submitHandler) {
		this.submitHandler = submitHandler
	},

	/**
	 * @param model the resulting data from the server
	 */
	finish: function(model) {
		this.trigger('done', model)
	}
})

export {
	handleMissingColumnsException,
	NewColumnNameChooserWizard,
	isMissingColumnsException,
	hasColumnsToRemapTo
}
